module.exports = __webpack_public_path__ + "img/s_blackorangeD-logo.13b5f77.png";